/** Test IDs for the public MVP area. */
export const PUBLIC_IDS = {
	brand: 'public-brand',
	searchInput: 'public-search-input',
	searchResults: 'public-search-results',
	home: 'public-home',
	eventsList: 'public-events-list',
	eventDetail: 'public-event-detail',
	placesList: 'public-places-list',
	placeDetail: 'public-place-detail',
	activitiesList: 'public-activities-list',
	activityDetail: 'public-activity-detail',
	map: 'public-map',
	directionsBtn: 'public-directions-button',
};

export const ADMIN_MANAGE = {
	placesPage: 'admin-places-page',
	activitiesPage: 'admin-activities-page',
	mediaPage: 'admin-media-page',
	placeCreateBtn: 'place-create-button',
	activityCreateBtn: 'activity-create-button',
	placeEditBtn: 'place-edit-button',
	activityEditBtn: 'activity-edit-button',
	coverUploadInput: 'cover-upload-input',
	mediaUploadInput: 'media-upload-input',
	navPlaces: 'nav-places-link',
	navActivities: 'nav-activities-link',
	navMedia: 'nav-media-link',
};
